<p-toast position="bottom-right"></p-toast>
<!--class="card"-->
<div style="margin:7px">
  <div class="row">
    <div class="col-md-12 col-sm-12" style="height:100%">
      <div class="info-box bg-gradient-info">
        <span class="info-box-icon"><i class="fas fa-chart-line"></i></span>
        <div class="info-box-content">
          <span class="info-box-text" style="font-style:italic"><strong>Utilization</strong></span>
          <span class="info-box-number">{{lineStats?.avgUtilization}} %</span>
          <div class="progress">
            <div class="progress-bar" style=" width:{{lineStats?.avgUtilization}}%"></div>
          </div>
          <span class="progress-description">
            {{lineStats?.avgUtilization}}% avg in 15 Days
          </span>
        </div>
        <div class="overlay dark" *ngIf="loading" style="width:100%">
          <i class="fas fa-2x fa-sync-alt fa-spin"></i>
        </div>
        <!--<div class="overlay dark " *ngIf="!loading && lineStats.avgUtilization==0">
      </div>-->
      </div>
    </div>

    <!-- #region Delay drop Stats -->
    <!--<div class="overlay dark " *ngIf="!loading && lineStats.avgDelay==0">
  </div>-->
    <!--</div>
  </div>
  <div class="col-3" style="height:100%">
    <div class="info-box bg-gradient-warning">
      <span class="info-box-icon"><i class="fas fa-cloud-download-alt"></i></span>
      <div class="info-box-content">
        <span class="info-box-text" style="font-style:italic"><strong>Dropping</strong></span>
        <span class="info-box-number">{{lineStats?.avgDropping}} %</span>
        <div class="progress">
          <div class="progress-bar" style=" width : {{lineStats?.avgDropping}}%"></div>
        </div>
        <span class="progress-description">
          {{lineStats?.avgDropping}}% avg in 15 Days
        </span>
      </div>
      <div class="overlay dark" *ngIf="loading" style="width:100%">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      </div>-->
    <!--<div class="overlay dark" *ngIf="!loading && lineStats.avgDelay==0">
  </div>-->
    <!--</div>
  </div>-->
    <!--<div class="col-3" style="height:100%">
  <div class="info-box bg-gradient-secondary">
    <span class="info-box-icon"><i class="fas fa-recycle"></i></span>
    <div class="info-box-content">
      <span class="info-box-text" style="font-style:italic"><strong>Delay (ms)</strong></span>
      <span class="info-box-number">{{lineStats?.avgDelay}}</span>
      <div class="progress">
        <div class="progress-bar-animated" style=" width:100%"></div>
      </div>
      <span class="progress-description">
        {{lineStats?.avgDelay}} ms avg in 15 Days
      </span>
    </div>
    <div class="overlay dark" *ngIf="loading" style="width: 100%; height: 100%">
      <i class="fas fa-2x fa-sync-alt fa-spin"></i>
    </div>-->
    <!-- #endregion -->




    <!--<div class="col-md-6 col-sm-12" style="height:100%">
      <div class="info-box bg-gradient-success">
        <span class="info-box-icon"><i class="fas fa-chart-bar"></i></span>
        <div class="info-box-content">
          <span class="info-box-text" style="font-style:italic">
            <strong>
              Availability&nbsp;-->
              <!--<a href="#/line-status-history-full/{{line.id}}/{{line.ipAddress}}">
              <i class="fas fa-info-circle" style="color: white;"></i>
            </a>-->
            <!--</strong>
          </span>
          <span class="info-box-number">{{lineStats?.availabilityPercent}} %</span>
          <div class="progress">
            <div class="progress-bar" style=" width:{{lineStats?.availabilityPercent}}%"></div>
          </div>
          <span class="progress-description">
            {{lineStats?.availabilityPercent}}% avg in 15 Days
          </span>
        </div>
        <div class="overlay dark" *ngIf="loading" style="width:100%">
          <i class="fas fa-2x fa-sync-alt fa-spin"></i>
        </div>-->
        <!--<div class="overlay dark" *ngIf="!loading && lineStats.availabilityPercent==0">
      </div>-->
      <!--</div>
    </div>-->

  </div>

</div>
